import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { WorkforceProfile } from "../../../Component/Model/Dto/WSP/WorkforceProfile";
import { TableColumn } from "../../../Component/Model/Table/Table";
import { getDateAsDashSeparatedString } from "../../../Helpers/DateFormatter";


interface WorkforceProfilePreviewRows {
    platformPeopleId: string;
    idNumber?: string;
    sdlNumber: string;
    siteName?: string;
    municipalityCode: { key: string; value: string };
    idType: { key: number; value: string };
    firstName: string;
    lastName: string;
    dateOfBirth?: string;
    gender: string;
    raceCode: { key: string; value: string };
    disabled: string;
    ofoCodeCategory: { key: string; value: string };
    employmentTypeCode: { key: string; value: string };
    nationalityTypeCode: { key: string; value: string };
}

interface WorkforceProfilePreviewTable {
    columns: Array<TableColumn>;
    rows: Array<WorkforceProfilePreviewRows>;
}


export function WorkforceProfilePreviewMapper(dataObject: WorkforceProfile[], isErrorReport: boolean): WorkforceProfilePreviewTable {

    const columns = GetColumns(isErrorReport);
    if (dataObject != undefined && dataObject.length > 0) {

        const rows = dataObject.map((item: WorkforceProfile, index: number) => ({
            platformPeopleId: item.platformPeopleId,
            sdlNumber: item.sdlNumber,
            siteName: item.siteName,
            municipalityCode: item.municipalityCode,
            idType: item.idType,
            idNumber: item.idNumber,
            firstName: item.firstName,
            lastName: item.lastName,
            dateOfBirth: getDateAsDashSeparatedString(item.dateOfBirth),
            gender: item.gender,
            raceCode: item.raceCode,
            disabled: item.disabled,
            ofoCodeCategory: item.ofoCodeCategory,
            employmentTypeCode: item.employmentTypeCode,
            nationalityTypeCode: item.nationalityTypeCode
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}


function GetColumns(isErrorReport: boolean): any {
    var result = [];
    if (!isErrorReport) {
        result = [
            { Header: 'Entity Id', accessor: 'sdlNumber', id: 'sdlNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'Site Name', accessor: 'siteName', id: 'siteName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'Municipality Code', accessor: 'municipalityCode', id: 'municipalityCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true },
            { Header: 'Id Type', accessor: 'idType', id: 'idType', Cell: ({ value }: any) => <DefaultCell value={value ? value.value : null } tooltip tooltipValue={value ? value.key :null} />, disableSortBy: true, infoIconEnabled: true},
            { Header: 'Employee Id', accessor: 'idNumber', id: 'idNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'First Name', accessor: 'firstName', id: 'firstName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'Last Name', accessor: 'lastName', id: 'lastName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'Date of Birth', accessor: 'dateOfBirth', id: 'dateOfBirth', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
            { Header: 'Gender', accessor: 'gender', id: 'gender', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'Equity', accessor: 'raceCode', id: 'raceCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true},
            { Header: 'Disability', accessor: 'disabled', id: 'disabled', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
            { Header: 'OFO Code', accessor: 'ofoCodeCategory', id: 'ofoCodeCategory', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true},
            { Header: 'Employment Type', accessor: 'employmentTypeCode', id: 'employmentTypeCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true},
            { Header: 'Nationality', accessor: 'nationalityTypeCode', id: 'nationalityTypeCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true},
        ];
    }
    else {
        result = [
            { Header: 'Entity Id', accessor: 'sdlNumber', id: 'sdlNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'Site Name', accessor: 'siteName', id: 'siteName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
            { Header: 'Municipality Code', accessor: 'municipalityCode', id: 'municipalityCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true, highlightCell: '#FEF5EA' },
            { Header: 'Id Type', accessor: 'idType', id: 'idType', Cell: ({ value }: any) => <DefaultCell value={value ? value.value : null } tooltip tooltipValue={value ? value.key :null} />, disableSortBy: true, infoIconEnabled: true, highlightCell: '#FEF5EA' },
            { Header: 'Employee Id', accessor: 'idNumber', id: 'idNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'First Name', accessor: 'firstName', id: 'firstName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'Last Name', accessor: 'lastName', id: 'lastName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'Date of Birth', accessor: 'dateOfBirth', id: 'dateOfBirth', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'Gender', accessor: 'gender', id: 'gender', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'Equity', accessor: 'raceCode', id: 'raceCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true, highlightCell: '#FEF5EA' },
            { Header: 'Disability', accessor: 'disabled', id: 'disabled', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, highlightCell: '#FEF5EA' },
            { Header: 'OFO Code', accessor: 'ofoCodeCategory', id: 'ofoCodeCategory', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true, highlightCell: '#FEF5EA' },
            { Header: 'Employment Type', accessor: 'employmentTypeCode', id: 'employmentTypeCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true, highlightCell: '#FEF5EA' },
            { Header: 'Nationality', accessor: 'nationalityTypeCode', id: 'nationalityTypeCode', Cell: ({ value }: any) => <DefaultCell value={value.value} tooltip tooltipValue={value.key} />, disableSortBy: true, infoIconEnabled: true, highlightCell: '#FEF5EA' },
        ];
    }
    return result;
}

export function ShowMissingDataMessage(dataObject: WorkforceProfile[]) {

    const hasMissingDataPerRow = dataObject.map((item: WorkforceProfile) => (
        (item.municipalityCode.key == null) ||
        (item.idType.key == null) ||
        (item.idNumber == null) ||
        (item.firstName == null) ||
        (item.lastName == null) ||
        (item.dateOfBirth == null) ||
        (item.gender == null) ||
        (item.raceCode.key == null) ||
        (item.disabled == null) ||
        (item.ofoCodeCategory.key == null) ||
        (item.employmentTypeCode.key == null) ||
        (item.nationalityTypeCode.key == null) ||
        (item.sdlNumber == null)
    ));

    var showHasMissingDataMessage = hasMissingDataPerRow.includes(true);
    return showHasMissingDataMessage;
}
